module.exports = __webpack_public_path__ + "static/6-745288c6257caac7fe735c4731878ba2.jpg";